import React, { useContext } from "react";
// @ts-ignore
import {useParams, Link} from "react-router-dom";
import styled from 'styled-components';
import { RankingsAndLevelsContext } from "../../../contexts/RankingsAndLevelsContext";
import Colors from "../../../assets/colors/Colors";
import {useTranslation} from "react-i18next";

interface Props {
  isLife: boolean
}

const StyledTier = styled.div`
  flex: 1;
  font-family: 'Mapfre-Light';
  font-size: 19px;

  & a {
    color: ${(props: Props) => props.isLife ? Colors.fontWhite : Colors.fontGray};
  }

  &.selected {
    font-family: 'Mapfre-Bold';
    font-size: 21px;
  }
`;

const GraphNavbar: React.FC = () => {
    let { yearCode, tierCode } = useParams();
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const { t } = useTranslation();
    return (
        <div style={{display: 'flex', flexDirection: 'row', padding: '5px 5px 5px 10px'}}>
            <div
              style={{
                flex: 3,
                alignItems: 'center',
                textAlign: 'center',
                fontSize: 60,
                fontFamily: 'Mapfre-Light',
                color: isLife ? Colors.fontWhite : Colors.fontGray
              }}
            >
              <span style={{fontFamily: 'Mapfre-Bold'}}>{t('mapContainer.title')}</span> { yearCode }
            </div>
            <div style={{flex: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <StyledTier className={tierCode == 'tier1' ? 'selected' : ''} isLife={isLife}>
                  <Link to={`/rankings/${yearCode}/tiers/tier1`}>Tier 1</Link>
                </StyledTier>
                <StyledTier className={tierCode == 'tier2' ? 'selected' : ''} isLife={isLife}>
                  <Link to={`/rankings/${yearCode}/tiers/tier2`}>Tier 2</Link>
                </StyledTier>
                <StyledTier className={tierCode == 'tier3' ? 'selected' : ''} isLife={isLife}>
                  <Link to={`/rankings/${yearCode}/tiers/tier3`}>Tier 3</Link>
                </StyledTier>
            </div>
        </div>
    )
};

export default GraphNavbar;
